import type { PluginLanguage } from '../types.js'

export const enTranslations = {
  'plugin-multi-tenant': {
    'assign-tenant-button-label': 'Assign Tenant',
    'assign-tenant-modal-title': 'Assign "{{title}}"',
    'field-assignedTenant-label': 'Assigned Tenant',
    'nav-tenantSelector-label': 'Filter by Tenant',
  },
}

export const en: PluginLanguage = {
  dateFNSKey: 'en-US',
  translations: enTranslations,
}
